module.exports = window["Bernie_l10nBundle_id_ID"];